/*  HAAUS30 Challenge, lightweight client-side enhancements.
    Loaded by any HAAUS30 section that needs it via {{ 'haaus30.js' | asset_url | script_tag }}.
    Kept intentionally small; no framework, no build step.  */

(function () {
  'use strict';

  /*  Countdown block: additional per-page enhancement that syncs across tabs
      when the same target is used in multiple places. Individual tick loop lives
      inline in snippets/haaus30-countdown.liquid; this file adds the visibility
      pause so background tabs don't burn CPU.  */
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-h30-countdown]');
    if (!nodes.length) return;

    var pauseAll = function () {
      nodes.forEach(function (n) { n.dataset.h30Visible = document.hidden ? '0' : '1'; });
    };
    document.addEventListener('visibilitychange', pauseAll);
    pauseAll();
  }

  /*  Waitlist form: client-side validation and Klaviyo-friendly AJAX submission.
      Falls back to native form POST if fetch fails.  */
  function initWaitlist() {
    var form = document.querySelector('[data-h30-waitlist]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var emailField = form.querySelector('input[name="email"]');
      var nameField  = form.querySelector('input[name="first_name"]');
      var optinField = form.querySelector('input[name="haaus30_waitlist_optin"]');

      if (!emailField.value || !nameField.value || !optinField.checked) {
        return; /* native required attributes will handle */
      }

      var endpoint = form.getAttribute('action') || '';
      var isPlaceholder = endpoint === '/' || endpoint === '';
      if (isPlaceholder) {
        /* No ESP endpoint configured yet; block submit and surface the state.  */
        e.preventDefault();
        showInlineMessage(form, "Waitlist is being set up. Please check back once enrolment opens.");
        return;
      }

      /* Otherwise let the browser POST natively so Klaviyo's hosted form
         action processes the submission normally.  */
    });

    function showInlineMessage(form, msg) {
      var existing = form.querySelector('[data-h30-waitlist-msg]');
      if (existing) { existing.textContent = msg; return; }
      var el = document.createElement('p');
      el.setAttribute('data-h30-waitlist-msg', '');
      el.style.cssText = 'margin:14px 0 0;font-size:14px;color:#6F4A24;';
      el.textContent = msg;
      form.appendChild(el);
    }
  }

  /*  Anchor scroll: any anchor whose href starts with #day- gets smooth scroll.  */
  function initDayAnchors() {
    var links = document.querySelectorAll('a[href^="#day-"]');
    if (!links.length) return;
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });
  }

  /*  Dashboard shortcut: on the dashboard, if the URL has ?jump=today the
      page scrolls to the Today block if present.  */
  function initDashboardJump() {
    if (!/\?.*\bjump=today\b/.test(window.location.search)) return;
    var today = document.querySelector('[data-mode="active"] .h30-dash__day');
    if (today) today.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /*  Boot.  */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCountdowns();
      initWaitlist();
      initDayAnchors();
      initDashboardJump();
    });
  } else {
    initCountdowns();
    initWaitlist();
    initDayAnchors();
    initDashboardJump();
  }
})();
